module.exports = __webpack_public_path__ + "static/media/capstone_permissions.59b1f1a1.yaml";